<div class="card card-custom" style="">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">Create Tags</h3>
    </div>
  </div>

  <div style="padding: 30px">
    <div class="example-container">
      <form [formGroup]="tagsForm">
        <kt-tags
          [controlObject]="tags"
          [appearance]="'fill'"
          category="Entity"
          [addOnly]="true"
          [canAddComponent]="true"
        ></kt-tags>
        <!--        <mat-form-field appearance="fill" style="width: 100%">-->
        <!--          <mat-label>Type</mat-label>-->
        <!--          <input matInput formControlName="type" required>-->
        <!--          <mat-error *ngIf="type.invalid">{{getErrorMessage(type)}}</mat-error>-->
        <!--        </mat-form-field>-->

        <div class="form-section form-section-first">
          <div>
            <mat-form-field appearance="fill" class="mat-form-field-fluid">
              <mat-label translate="CONTACT_RELATIONSHIP.FORM.ENTITY_TYPE">Entity Type</mat-label>
              <mat-select formControlName="entity_type" #ts required>
                <mat-option value="ALL_ENTITIES"
                  ><span translate="ENTITY.ALL_ENTITIES">All Entities</span></mat-option
                >
                <mat-option value="DOCTOR"
                  ><span translate="ENTITY.DOCTOR">Doctor</span></mat-option
                >
                <mat-option value="PATIENT"
                  ><span translate="ENTITY.PATIENT">Patient</span></mat-option
                >
                <mat-option value="FACILITY"
                  ><span translate="ENTITY.FACILITY">Facility</span></mat-option
                >
                <mat-option value="CONTACT"
                  ><span translate="ENTITY.CONTACT">CONTACT</span></mat-option
                >
              </mat-select>
              <mat-error *ngIf="isControlHasError('entity_type', 'required')">
                Required field
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </form>
    </div>
  </div>

  <mat-dialog-actions align="end" style="padding: 18px 36px">
    <div style="width: 100%; display: flex; justify-content: flex-end">
      <div class="d-flex justify-content-between">
        <div class="mr-2"></div>
        <div>
          <button
            type="button"
            mat-raised-button
            cdkFocusInitial
            matTooltip="Cancel"
            (click)="onCancelClick()"
            [disabled]="disableBtns"
            (click)="onCancelClick()"
          >
            Cancel</button
          >&nbsp;
          <button
            type="submit"
            mat-raised-button
            color="primary"
            matTooltip="Create"
            style="margin-right: 5px"
            [disabled]="disableBtns"
            (click)="onSubmit()"
          >
            {{ 'Create' }}
          </button>
        </div>
      </div>
    </div>
  </mat-dialog-actions>
</div>
